class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.dispatchVariantChange();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent(
        'variant-change',
        {
          bubbles: true,
          variant: this.currentVariant,
          detail: {
            variant: this.currentVariant
          }
        }
      )
    );
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }

        // Update the inventory quantity hidden input
        const inventoryQtyDestination = document.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
        const inventoryQtySource = html.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
        inventoryQtyDestination.value = inventoryQtySource.value;

        // get the product info wrapper
        this.productInfoWrapper = document.querySelector('[data-product-wrapper]');

        // Update the variant title
        this.variantTitle = this.productInfoWrapper.querySelector('[data-variant-title]');
        this.variantTitle.innerHTML = this.currentVariant.title;

        // Update the product specifications
        this.updateSpecs();

        // Update prices - Visually and on Hidden elements used on the calculator
        const priceID = `price-${this.dataset.section}`;
        const priceDestination = document.getElementById(priceID);
        const priceDestinationCalculator = document.querySelector('[data-product-price]');
        const priceDestinationUnitCalculator = document.querySelector('[data-calculator-price]');
        const priceDestinationUnitDisplay = document.querySelector('[data-calculator-unit-price]');
        const priceSource = html.getElementById(priceID);
        if (priceSource) {
          if (priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
          if (priceDestinationCalculator) {
            const finalPrice = priceSource.querySelector('.price__last');
            priceDestinationCalculator.innerHTML = finalPrice.innerHTML;
          }
          // set the right product unit price on this element - it'll be used for price calculations
          if (priceDestinationUnitCalculator) priceDestinationUnitCalculator.innerHTML = this.currentVariant.price;
          // update the unit price display in the calculator
          if (priceDestinationUnitDisplay) priceDestinationUnitDisplay.textContent = priceSource.querySelector('.price__last').textContent.trim();
          // if there's a product calculator, calculate the final price when there's a variant change
          document.querySelector('product-calculator')?.calculate();
        }

        // Update stock amount
        this.stockVariants = this.productInfoWrapper.querySelectorAll('[data-stock-variant-id');
        this.stockVariants.forEach(stockVariant => {
          stockVariant.style.display = 'none';
          this.stockVariantId = parseInt(stockVariant.dataset.stockVariantId);
          if (this.currentVariant.id === this.stockVariantId) {
            stockVariant.style.display = 'table';
          }
        });

        // update Floori url on sku change
        const livePreviewButton = this.productInfoWrapper.querySelector('[data-product-live-preview]');
        if (livePreviewButton) {
          let newURL = livePreviewButton.dataset.src.split('=')[0] + '=' + this.currentVariant.sku;
          livePreviewButton.setAttribute('data-src',newURL);
        }

      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  updateSpecs() {
    this.specsWrapper = this.productInfoWrapper.querySelector('[data-product-specs-wrapper]');
    this.specs = this.specsWrapper.querySelector('[data-product-specs]');
    this.specsData = JSON.parse(this.specs.dataset.productSpecs);

    if (!this.specsData.specs || !this.specsData.row_template || !this.specsData.divider) {
      return;
    }

    // Loop the specs
    this.specsData.specs.forEach(spec => {
      this.variantSpecs = spec.split(this.specsData.divider);
      this.variantId = parseInt(this.variantSpecs[0].split(':')[1]);

      if (this.variantId === this.currentVariant.id) {
        this.rowHtml = this.specsData.row_template;
        this.specHtml = '';

        // Loop the specs to create html from the template
        this.variantSpecs.forEach((variantSpec, i) => {
          this.pair = this.variantSpecs[i];
          this.key = this.pair.split(':')[0];
          this.value = this.pair.split(':')[1];

          // Skip the variant ID
          if (this.key == 'variant_id') {
            return;
          }
          this.specHtml = this.specHtml + this.rowHtml.replace('[key]', this.key ).replace('[value]', this.value );

        });

        // Insert the html
        this.specs.innerHTML = this.specHtml;

        // break the loop
        return false;
      }

    });
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}

